"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = __importDefault(require("../config"));
const eventapi_client_1 = __importDefault(require("@telia-oa/eventapi-client"));
class OnlineHelpEventStore {
    constructor(rootStore) {
        Object.defineProperty(this, "eventApi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getOaCrmWebapiBuildParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return {
                    env: config_1.default.onlineHelpEnvironment,
                    project: 'brandfree-web'
                };
            }
        });
        Object.defineProperty(this, "getClientId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.ssoStore.customerId && `${this.ssoStore.customerId}`;
            }
        });
        Object.defineProperty(this, "recordSimpleEvent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (action) => {
                this.eventApi.recordSimpleEvent({ action: `ACTION_${action}` });
            }
        });
        Object.defineProperty(this, "recordSimpleEventWithCustomerType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (action) => {
                const customerTypePrefix = this.ssoStore.isBusinessCustomer ? 'B2B_' : 'B2C_';
                await this.recordSimpleEvent(customerTypePrefix + action);
            }
        });
        this.ssoStore = rootStore.ssoStore;
        const { env, project } = this.getOaCrmWebapiBuildParams();
        this.eventApi = new eventapi_client_1.default(env, project, this.getClientId);
    }
}
exports.default = OnlineHelpEventStore;
